import "./HomeTestimonial.scss";
import { Fragment, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import TestiCard from "./testiCard/TestiCard";
import { Autoplay, FreeMode } from "swiper/modules";

const HomeTestimonial = ({ dataList, title }) => {
  const [heightList, setHeightList] = useState([]);
  const swiperRef = useRef(null);

  return (
    <Fragment>
      <section className="home_multi_slider p_t p_b">
        <div className="content_wrap">
          <div className="title_part">
            <h2 className="gold">
              {title &&
                title
                  ?.split("")
                  .map((char, k) => (
                    <motion.span
                      initial={{ translateX: 24, opacity: 0 }}
                      whileInView={{ translateX: 0, opacity: 1 }}
                      transition={{
                        duration: 0.4,
                        ease: "easeInOut",
                        delay: 0.05 * k,
                      }}
                      key={k}
                    >
                      {char}
                    </motion.span>
                  ))
                  .concat("")}
            </h2>
          </div>
        </div>
        <div
          onMouseEnter={() => swiperRef?.current?.swiper?.autoplay?.stop()}
          onMouseLeave={() => swiperRef?.current?.swiper?.autoplay?.start()}
        >
          {dataList?.length > 0 ? (
            <Fragment>
              <Swiper
                ref={swiperRef}
                loop={true}
                slidesPerView={4}
                spaceBetween={24}
                autoplay={{
                  delay: 0,
                  disableOnInteraction: false,
                }}
                speed={3000}
                freeMode={true}
                modules={[Autoplay, FreeMode]}
                breakpoints={{
                  1250: {
                    slidesPerView: 4,
                  },
                  800: {
                    slidesPerView: 3,
                  },
                  550: {
                    slidesPerView: 2,
                  },
                  10: {
                    slidesPerView: 1,
                  },
                }}
              >
                {dataList?.map((data, k) => {
                  return (
                    <SwiperSlide key={k}>
                      <TestiCard
                        data={data}
                        setHeightList={setHeightList}
                        h={Math.max(...heightList)}
                        id={data?._id}
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Fragment>
          ) : (
            <p className="text-center">Data not found...</p>
          )}
        </div>
      </section>
    </Fragment>
  );
};

export default HomeTestimonial;
